import { api } from "./api";

export const createProductApi = (params) => {
    return api.post(`/product/create`, JSON.stringify(params));
};

export const editProductApi = (params) => {
    return api.post(`/product/edit`, JSON.stringify(params));
};

export const listProductApi = (params) => {
    return api.get(`/product/list`, { params });
};

export const viewProductApi = (params) => {
    return api.get(`/product/view`, { params });
};

export const deleteProductApi = (params) => {
    return api.post(`/product/delete`, JSON.stringify(params));
};

export const productBulkUploadApi = (params) => {
    return api.post(`/product/bulk-upload`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};